import { Injectable } from '@angular/core';
import { VariableEnvironnementUserService } from './variable-environnement-user.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { Model_VariableEnvironnementUser } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class VariableEnvironnementUserOnlineService extends VariableEnvironnementUserService {
    constructor(
        private _httpClient: HttpClient, 
        private _apiService: ApiService
    ) {
        super();
    }

    doSyncVariablesEnvironnementUserAction(_var: Model_VariableEnvironnementUser) {
        return this._httpClient.post<Model_VariableEnvironnementUser>(this._apiService.endPoints.doSyncVariablesEnvironnementAction_SynchronisationPeripherique, _var)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
}